import React from "react";
import {FormattedMessage, useIntl} from "react-intl";
import {TipCurrency} from "../model/constants";
import {ShareKeyType, payByCard} from "../model/paymentApi";
import {getLanguage} from "../translations";

export function PayByCard({
    price,
    currency,
    kind,
    shareKey,
    shareKeyType,
}: {
    price: string;
    currency: TipCurrency;
    kind: "primary" | "secondary";
    shareKey: string;
    shareKeyType: ShareKeyType;
}) {
    const intl = useIntl();

    const handleLoad = () => {
        payByCard({
            language: getLanguage(),
            price: {amount: parseInt(price), ccy: currency},
            redirectUri: window.location.href,
            shareKey: shareKey,
            shareKeyType: shareKeyType,
        })
            .then((response) => (window.location.href = response.processUri))
            .catch(() => alert(intl.formatMessage({id: "generic_error"})));
    };

    return (
        <button
            onClick={handleLoad}
            className={`${kind}-card-button`}
            disabled={Number(price) === 0}
            data-cy="tracking-tip-by-card"
        >
            <FormattedMessage id="card_payment" />
        </button>
    );
}
